module.exports = __webpack_public_path__ + "static/img/banner1620.516c101.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/banner1620.jpg
// module id = j7Tj
// module chunks = 6